import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import Lightbox from '../../components/ui/Lightbox';
import clubDanseData from '../../data/clubDanseData.json';
import { SparklesIcon, UserGroupIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ClubDansePage() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="max-w-5xl mx-auto space-y-12 animate-fade-in px-4">
      {/* Hero */}
      <Card variant="elevated" className="p-6 sm:p-10 flex flex-col md:flex-row items-center gap-8">
        <div className="w-36 h-36 sm:w-44 sm:h-44 rounded-full overflow-hidden border-4 border-white shadow-acem-md flex-shrink-0 bg-acem-surface-container-low">
          <img
            src={clubDanseData.imageHero}
            alt="Club de Danse Traditionnelle ACEM Fès"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex-1 space-y-3 text-center md:text-left">
          <Badge variant="accent">ACEM Fès Art & Patrimoine</Badge>
          <h1 className="font-title text-2xl sm:text-4xl font-extrabold text-acem-primary-dark">
            Club de Danses Traditionnelles
          </h1>
          <p className="text-xs sm:text-sm text-acem-text/85 leading-relaxed">
            {clubDanseData.descriptionHero}
          </p>
        </div>
      </Card>

      {/* Objectifs */}
      <section className="space-y-4">
        <div className="border-b border-acem-border pb-2">
          <h2 className="font-title text-xl font-bold text-acem-primary-dark flex items-center gap-2">
            <SparklesIcon className="w-5 h-5 text-acem-primary" aria-hidden="true" />
            <span>Nos Objectifs Culturels</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {clubDanseData.objectifs?.map((obj, idx) => (
            <Card key={idx} variant="default" className="p-5 text-center space-y-2">
              <div className="text-3xl">{obj.icone}</div>
              <h3 className="font-bold text-sm text-acem-text">{obj.titre}</h3>
              <p className="text-xs text-acem-muted">{obj.description}</p>
            </Card>
          ))}
        </div>
      </section>

      {/* Styles de danses traditionnelles */}
      {clubDanseData.stylesDeDanses && clubDanseData.stylesDeDanses.length > 0 && (
        <section className="space-y-6">
          <div className="border-b border-acem-border pb-2">
            <h2 className="font-title text-xl sm:text-2xl font-bold text-acem-primary-dark flex items-center gap-2">
              <UserGroupIcon className="w-5 h-5 text-acem-primary" aria-hidden="true" />
              <span>Les Styles de Danses Pratiqués</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {clubDanseData.stylesDeDanses.map((style, idx) => (
              <Card key={idx} variant="elevated" className="p-5 space-y-3">
                <div
                  onClick={() => setSelectedImage(style.image)}
                  className="h-48 rounded-xl overflow-hidden bg-acem-surface-container-low cursor-pointer group shadow-sm flex items-center justify-center"
                >
                  <img
                    src={style.image}
                    alt={style.titre}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <h3 className="font-title font-bold text-lg text-acem-primary-dark">
                  {style.titre}
                </h3>
                <p className="text-xs sm:text-sm text-acem-text/80 leading-relaxed">
                  {style.description}
                </p>
              </Card>
            ))}
          </div>
        </section>
      )}

      {/* Rejoindre le club CTA */}
      <Card variant="glass" className="p-8 text-center space-y-3 max-w-2xl mx-auto">
        <h3 className="font-title text-2xl font-bold text-acem-primary-dark">
          Envie de célébrer et faire vivre nos traditions ?
        </h3>
        <p className="text-xs sm:text-sm text-acem-muted max-w-md mx-auto leading-relaxed">
          Rejoignez la troupe de danses traditionnelles de l'ACEM Fès pour nos prochains galas et événements culturels.
        </p>
        <div className="pt-2">
          <Button
            as="a"
            href="mailto:acemfes7@gmail.com"
            variant="primary"
            size="md"
            className="inline-flex items-center gap-2"
          >
            <EnvelopeIcon className="w-4 h-4" aria-hidden="true" />
            <span>Nous rejoindre : acemfes7@gmail.com</span>
          </Button>
        </div>
      </Card>

      {/* Lightbox */}
      {selectedImage && (
        <Lightbox
          src={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </div>
  );
}
